export default __webpack_public_path__ + "static/media/Group 744.21a6fe6d.svg";